import { type Token } from '@/shared/assets/tokens';
import QuestionMarkTooltip from '@/shared/components/QuestionMarkTooltip';
import { UsdAmount } from '@/shared/components/UsdAmount';
import { BOOST_FEE, EGRESS_FEE, INGRESS_FEE, NETWORK_FEE, BROKER_FEE } from '@/shared/constants';
import ArrowIcon from '@/shared/icons/flip-ui-kit/small/Arrow';
import Bolt from '@/shared/icons/flip-ui-kit/small/Bolt';
import BrokerIcon from '@/shared/icons/flip-ui-kit/small/Broker';
import FireIcon from '@/shared/icons/flip-ui-kit/small/Fire';
import Send from '@/shared/icons/flip-ui-kit/small/Send';
import type TokenAmount from '@/shared/utils/TokenAmount';

const ExpandedSwapDetailValueRow = ({
  label,
  icon,
  children,
  tooltipContent,
  tooltipLink,
}: {
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode | string;
  tooltipContent?: React.ReactNode;
  tooltipLink?: string;
}) => (
  <div className="flex w-full items-center justify-between font-aeonikMedium text-13">
    <div className="flex flex-row items-center gap-x-1.5 text-cf-light-2">
      <div>{icon}</div>
      <span>{label}</span>
      <QuestionMarkTooltip content={tooltipContent} link={tooltipLink} />
    </div>
    {children}
  </div>
);

export const PlatformFees = ({
  fees,
}: {
  fees: {
    amount: TokenAmount;
    token: Token;
    name: string;
  }[];
}) =>
  fees.map((fee) => {
    let icon;
    switch (fee.name) {
      case INGRESS_FEE:
        icon = <ArrowIcon direction="down" />;
        break;
      case EGRESS_FEE:
        icon = <Send />;
        break;
      case NETWORK_FEE:
        icon = <FireIcon />;
        break;
      case BOOST_FEE:
        icon = <Bolt />;
        break;
      case BROKER_FEE:
        icon = <BrokerIcon />;
        break;
      default:
        break;
    }
    return (
      <ExpandedSwapDetailValueRow
        key={`${fee.name}-${fee.token.symbol}`}
        icon={icon}
        label={fee.name}
        tooltipContent={
          fee.name === NETWORK_FEE &&
          'Fixed fee taken in $USDC by the protocol to buy and burn $FLIP'
        }
        tooltipLink={
          fee.name === NETWORK_FEE
            ? 'https://docs.chainflip.io/protocol/token-economics/incentive-design-emission-and-burning#the-network-fee'
            : undefined
        }
      >
        <div>
          <span className="text-white">
            {fee.amount.toCapped()} {fee.token.symbol}{' '}
          </span>
          <span className="text-cf-light-2">
            (<UsdAmount token={fee.token} tokenAmount={fee.amount} />)
          </span>
        </div>
      </ExpandedSwapDetailValueRow>
    );
  });
